export default __webpack_public_path__ + "static/media/news-source-logo.92a10990.svg";